import React from 'react';

// I don't like this, but just to keep Loader same as other pages :)
const Loader = ({ message = '' }) => (
  <div data-testid="loader-element" className="loading-mask">
    <div className="ring">
      <div />
      <div />
      <div />
      <div />
    </div>
    <strong>{message}</strong>
  </div>
);

export default Loader;
